module.exports = __webpack_public_path__ + "static/img/2.5f1d967.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/zh/2.png
// module id = KFBK
// module chunks = 0